import React, { useState, useEffect } from 'react';
import moment from "moment-timezone";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import { Box, LinearProgress, TableBody } from "@material-ui/core";
import { TableCell, TableFooter, TablePagination, TableRow } from '@material-ui/core';
import InputSearch from 'components/Input/InputSearch';
import AppUtil from 'utilities/AppUtil';
import AppTable from '../../Table/AppTable';
import TablePaginationActions from '../../Table/TablePaginationActions';
import { getTimesheetDetail } from 'store/slices/booking';
import { fetchTimesheetDetail } from 'store/slices/booking';
import { fetchWorkerDetail } from 'store/slices/worker';
import AppColor from 'utilities/AppColor';
import { SYSTEM_ROLE } from 'config/AppConfig';
import { getAuthInfo } from 'store/slices/auth';
// import { getAuthInfo } from 'store/slices/auth';


const headCells = [
  {
    id: "date",
    numeric: "left",
    disablePadding: false,
    label: "label.date",
    sort: true,
  },
  {
    id: "shiftType",
    numeric: "left",
    disablePadding: false,
    label: "label.shift",
    sort: false,
  },
  {
    id: "client",
    numeric: "left",
    disablePadding: false,
    label: "label.participantName",
    sort: true,
  },
  {
    id: "jobName",
    numeric: "left",
    disablePadding: false,
    label: "label.jobName",
    sort: false,
  },
  {
    id: "bookingStartTime",
    numeric: "center",
    disablePadding: false,
    label: "label.bookingStartTime",
    sort: true,
  },
  {
    id: "bookingEndTime",
    numeric: "center",
    disablePadding: false,
    label: "label.bookingEndTime",
    sort: true,
  },
  {
    id: "adjustedBookingTime",
    numeric: "center",
    disablePadding: false,
    label: "label.adjustedBookingTime",
    sort: false,
  },
  {
    id: "totalHours",
    numeric: "center",
    disablePadding: false,
    label: "label.totalHours",
    sort: true,
  },
  {
    id: "progressNote",
    numeric: "left",
    disablePadding: false,
    label: "label.progressNote",
    sort: false,
  },
  {
    id: "km",
    numeric: "center",
    disablePadding: false,
    label: "label.kmTraveled",
    sort: true,
  },
  {
    id: "reimbursement",
    numeric: "center",
    disablePadding: false,
    label: "label.reimbursement",
    sort: true,
  },
  {
    id: "totalPay",
    numeric: "center",
    disablePadding: false,
    label: "label.totalPay",
    sort: true,
  },
];
const STYLE = {
  hyperLink: {
    color: AppColor.blue,
    textDecoration: 'underline'
  },
  nameFilter: {
    fontSize: '20px',
    fontWeight: 'bold'
  }
}

const TimesheetDetail = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  const [queries, setQueries] = useState({
    is_asc: false,
    page_number: 1,
    page_size: 10,
    search_key: "",
    sort_field: "created_date",
  });

  const userInfo = useSelector(getAuthInfo);
  const timesheetDetail = useSelector(getTimesheetDetail);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [searchKey, setSearchKey] = useState("");
  const [worker, setWorker] = useState();

  const emptyRows = data.length === 0;
  // const authInfo = useSelector(getAuthInfo) || {};
  // const { companyId } = authInfo;

  const _loadWorkerDetail = () => {
    if (id) {
      dispatch(fetchWorkerDetail({workerId: id}))
      .then(({ payload }) => {
        setLoading(false);
        if (payload) {
          setWorker(payload);
        }
      });
    }
  }
  const _loadData = async ({ page_number, page_size, search_key, is_asc, sort_field } = {}) => {
    const newQueries = {
      ...queries,
    };
    if (page_number) {
      newQueries.page_number = page_number;
    }
    if (page_size) {
      newQueries.page_size = page_size;
    }
    if (sort_field) {
      newQueries.sort_field = sort_field;
    }
    newQueries.id = id;
    newQueries.search_key = search_key || "";
    newQueries.is_asc = !(!is_asc || false);
    
    setLoading(true);
    dispatch(fetchTimesheetDetail({...newQueries}))
    .then(({ payload }) => {
      setQueries(newQueries);
      setLoading(false);
      if (payload) {
        setTotalElements(payload.totalElements);
      }
    });
  };

  const handleChangePage = (event, newPage) => {
    _loadData({ ...queries, page_number: newPage + 1 });
    AppUtil.scrollToTopById("main-panel");
  };

  const handleChangeRowsPerPage = (event) => {
    _loadData({
      ...queries,
      page_number: 1,
      page_size: parseInt(event.target.value),
    });
    AppUtil.scrollToTopById("main-panel");
  };

  const onRequestSort = (event, property) => {
    _loadData({
      ...queries,
      sort_field: property,
      is_asc:
        ( property === 'title' ||
          property === queries.sort_field) ? queries.is_asc !== true : true,
    });
  };

  const onSearch = (value) => {
    setSearchKey(value);
    _loadData({
      ...queries,
      search_key: value,
      page_number: 1,
    });
  };

  useEffect(() => {
    if (userInfo.role !== SYSTEM_ROLE.COMPANY) {
      history.push('/');
      return;
    }
    _loadWorkerDetail();
    _loadData(queries);
  }, []);

  useEffect(() => {
    if (timesheetDetail){
      setData(timesheetDetail);
    }
  }, [timesheetDetail])

  const renderAdjustedBookingTime = (start, end) => {
    if (!start && !end) {
      return <span style={{color: AppColor.red}}>{t('label.notStart')}</span>
    }
    if (start && !end) {
      return (
        <span>
          {`${moment(start).format('HH:mm')} - `} 
          <span style={{color: AppColor.red}}>{t('jobStatus.ON_GOING')}</span>
        </span>
      )
    }
    if (start && end) {
      return <span>{`${moment(start).format('HH:mm')} - ${moment(end).format('HH:mm')}`}</span>
    }
  }

  return (
    <div style={{ minHeight: '450px'}}>
      {
        worker && 
        <Box my={3}>
          <span style={STYLE.nameFilter}>{`${worker.firstName} ${worker.lastName}`}</span>
        </Box>
      }
      <Box my={3}>
        <InputSearch onSearch={onSearch} searchText={searchKey} />
      </Box>
      <AppTable
        onRequestSort={onRequestSort}
        order={queries.is_asc === true ? "asc" : "desc"}
        orderBy={queries.sort_field === 'workerName' ? 'workerName' : queries.sort_field}
        headCells={headCells}
        rowCount={data.length}
      >
        <TableBody>
          {loading && (<TableRow>
            <TableCell colSpan={headCells.length + 1} padding="none">
              <LinearProgress/>
            </TableCell>
          </TableRow>)}
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell >{moment.utc(row.date).format('DD/MM/YYYY')}</TableCell>
              <TableCell>{t(`shift.${row.shiftType}`)}</TableCell>
              <TableCell title={row.client}>{AppUtil.shortenText(row.client, 20)}</TableCell>
              <TableCell title={row.jobTitle}>{AppUtil.shortenText(row.jobTitle, 20)}</TableCell>
              <TableCell style={STYLE.hyperLink}>
                <Link  to={`/admin/booking/${row.bookingId}`}  className="text-center">
                  {moment(row.bookingStartTime).format('HH:mm')}
                </Link>
              </TableCell>
              <TableCell align='center'>{moment(row.bookingEndTime).format('HH:mm')}</TableCell>
              <TableCell align='center'>
                {renderAdjustedBookingTime(row.adjustBookingStartTime, row.adjustBookingEndTime)}
              </TableCell>
              <TableCell align='center'>
                {row.adjustBookingStartTime && row.adjustBookingEndTime && row.totalHours && row.totalHours !== 0 
                ? AppUtil.formatNumber(row.totalHours) : '-'}
              </TableCell>
              <TableCell align='center'>{row.progressNote ? 'Y' : 'N'}</TableCell>
              <TableCell align='center'>
                {row.kmTraveled && row.kmTraveled !== 0 ? AppUtil.formatNumber(row.kmTraveled) : '-'}
              </TableCell>
              <TableCell align='center'>
                {row.reimbursement && row.reimbursement !== 0 ? t('price.iconPrice', {value: AppUtil.formatMoney(row.reimbursement)}) : '-'}
              </TableCell>
              {
                row.payrollId ?
                <TableCell align='center' style={STYLE.hyperLink}>
                  <Link  to={`/admin/payroll/${row.payrollId}`}  className="text-center">
                    {row.payToStaff && row.totalHours && row.payToStaff !== 0 && row.totalHours !== 0
                     ? t('price.iconPrice', {value: AppUtil.formatMoney(row.payToStaff * row.totalHours)})
                     : '-'}
                  </Link>
                </TableCell> :
                <TableCell align='center'>
                  {row.payToStaff && row.totalHours && row.payToStaff !== 0 && row.totalHours !== 0
                     ? t('price.iconPrice', {value: AppUtil.formatMoney(row.payToStaff * row.totalHours)})
                     : '-'}
                </TableCell>
              }
            </TableRow>
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 }}>
              <TableCell colSpan={headCells.length} className="text-center">
                {t("label.no_data")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              colSpan={headCells.length}
              count={totalElements}
              rowsPerPage={queries.page_size}
              page={queries.page_number - 1}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              labelRowsPerPage={`${t("label.rows_per_page")}:`}
              labelDisplayedRows={({ from, to, count }) =>
                t("label.from_to", {
                  from,
                  to,
                  count:
                    count !== -1 ? count : `${t("text.more_than")} ${to}`,
                })
              }
            />
          </TableRow>
        </TableFooter>
      </AppTable>
    </div>
  );
}

export default TimesheetDetail;